export default "__VITE_ASSET__DXOtUc70__"